import { Typography } from "@mui/material";

/**
 * Exibe um contador de caracteres restantes quando faltam 10 ou menos.
 * @param {{ value: string, maxLength: number }} props
 */
function CharCounter({ value, maxLength }) {
  const length = value?.length || 0;
  const remaining = maxLength - length;

  if (remaining > 10) return null;

  return (
    <Typography
      variant="caption"
      sx={{
        color: remaining <= 5 ? "error.main" : "text.secondary",
        mr: 1,
        fontSize: "0.75rem",
        whiteSpace: "nowrap",
      }}
    >
      {length}/{maxLength}
    </Typography>
  );
}

export default CharCounter;
